import { LitElement } from 'lit';
import { unsafeStatic, html } from "lit/static-html.js";
import { i18n } from '@lingui/core';
import { messages as nbMessages} from '../src/raw/circle-user/locales/nb/messages.mjs';
import { messages as enMessages} from '../src/raw/circle-user/locales/en/messages.mjs';
import { messages as fiMessages} from '../src/raw/circle-user/locales/fi/messages.mjs';
import { activateI18n } from '../src/utils/i18n';
activateI18n(enMessages, nbMessages, fiMessages);


export class IconCircleUser24 extends LitElement {
  render() {
      const title = i18n.t({ message: `Circle with user profile`, id: 'icon.title.circle-user', comment: 'Title for circle-user icon' });
      
      return html`<svg xmlns="http://www.w3.org/2000/svg"width="24"height="24"fill="none"viewBox="0 0 24 24" part="w-icon-circle-user-24-part">${unsafeStatic(`<title>${title}</title>`)}<path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M12 15a5.25 5.25 0 1 0 0-10.5A5.25 5.25 0 0 0 12 15"></path><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M12 23.25c6.213 0 11.25-5.037 11.25-11.25S18.213.75 12 .75.75 5.787.75 12 5.787 23.25 12 23.25"></path><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M7.476 7.084A8.7 8.7 0 0 0 13.75 9.75a8.7 8.7 0 0 0 3.39-.685M5.087 20.876a9.745 9.745 0 0 1 13.805-.021"></path></svg>`; }
}
if (!customElements.get('w-icon-circle-user-24')) {
  customElements.define('w-icon-circle-user-24', IconCircleUser24);
}